import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FilterState {
  searchQuery: string;
  selectedCuisines: number[];
  priceRange: number[];
  sortBy: string | null;
  viewMode: 'map' | 'list';
}

const initialState: FilterState = {
  searchQuery: '',
  selectedCuisines: [],
  priceRange: [],
  sortBy: null,
  viewMode: 'list',
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSelectedCuisines: (state, action: PayloadAction<number[]>) => {
      state.selectedCuisines = action.payload;
    },
    setPriceRange: (state, action: PayloadAction<number[]>) => {
      state.priceRange = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string | null>) => {
      state.sortBy = action.payload;
    },
    setViewMode: (state, action: PayloadAction<'map' | 'list'>) => {
      state.viewMode = action.payload;
    },
    resetFilters: (state) => {
      state.searchQuery = '';
      state.selectedCuisines = [];
      state.priceRange = [];
      state.sortBy = null;
    },
  },
});

export const {
  setSearchQuery,
  setSelectedCuisines,
  setPriceRange,
  setSortBy,
  setViewMode,
  resetFilters,
} = filterSlice.actions;

export default filterSlice.reducer; 